import routerOptions0 from "/app/cms_public/node_modules/.pnpm/nuxt@3.18.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.6_@types+node@25.9.2_@vue+compiler-sfc@3_fewkefcqm3wb6tuqpn43qysk5i/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/cms_public/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}